<template>
  <navigation
    v-bind:sub_components_list="subComponentsList"
    v-bind:labels="labels"
    v-bind:default_key="'sessions'"
    v-bind:sync_with_route="true" />
</template>

<script setup lang="ts">
  import navigation from '@/views/_espace/_refonte/formateur/utils/navigation.vue';
  import candidatures from '@/views/_espace/_refonte/formateur/_candidatures/candidatures.vue';
  import sessions from '@/views/_espace/_refonte/formateur/_candidatures/sessions.vue';

  const labels: Record<string, string> = {
    sessions: 'Navette en cours',
    candidatures: 'Mes candidatures en cours'
  };

  const subComponentsList = {
    sessions,
    candidatures
  };
</script>

<style lang="scss" scoped></style>
